import { MapPin, ParkingCircle, Bus, ArrowRightCircle } from 'lucide-react'; // usa icone lucide-react

export default function ComeRaggiungerci() {
  return (
<section className="max-w-7xl mx-auto px-6 py-16">
  {/* Titolo sopra le 3 colonne */}
  <h2 className="text-4xl font-extrabold text-center mb-16 mt-20">COME RAGGIUNGERCI</h2>

  {/* Griglia a 3 colonne */}
  <div className="grid md:grid-cols-3 gap-10 items-start">
    {/* Colonna 1: logo e indirizzo */}
    <div className="flex flex-col items-center text-center">
      <img
        src="/logoCascina.svg"
        alt="Cascina delle Rose"
        className="w-64 mb-4"
      />
      <p className="w-64 text-left text-lg">
        Via delle Industrie, 9<br />61040 Sant’Ippolito PU
      </p>
      <a
        href="https://maps.app.goo.gl/h27gowznyFNfqX3x9"
        target="_blank"
        rel="noopener noreferrer"
        className="mt-6 bg-[#FFD500] hover:bg-yellow-400 text-center w-64 transition text-black font-semibold px-8 py-5 rounded-full flex items-center justify-center gap-2"
      >
        <MapPin className="h-5" />
        <span>MAPPA</span>
      </a>
    </div>

    {/* Colonna 2: indicazioni */}
    <ul className="space-y-6 text-lg">
      {[
        {
          titolo: "Da Nord (Bologna / Rimini):",
          testo:
            "A14 uscita Fano, proseguire su SS73bis in direzione Fossombrone, poi seguire le indicazioni per Sant’Ippolito.",
        },
        {
          titolo: "Da Sud (Ancona / Pescara):",
          testo:
            "A14 uscita Fano, proseguire su SS73bis in direzione Fossombrone, poi seguire le indicazioni per Sant’Ippolito.",
        },
        {
          titolo: "Da Roma:",
          testo:
            "E45 fino a Perugia, poi seguire la SS3 Flaminia in direzione Fano.",
        },
      ].map((voce, i) => (
        <li key={i} className="flex items-start gap-4">
          <span className="text-yellow-400 mt-1">
            <ArrowRightCircle className="w-6 h-6 stroke-[3]" />
          </span>
          <div>
            <p className="font-semibold">{voce.titolo}</p>
            <p>{voce.testo}</p>
          </div>
        </li>
      ))}
    </ul>

    {/* Colonna 3: parcheggio */}
    <div className="space-y-10 text-left text-lg">
      <div className="flex items-start gap-4">
        <ParkingCircle className="w-8" />
        <p>
          Parcheggio disponibile<br />
          ampio spazio davanti al ristorante e nelle aree limitrofe.
        </p>
      </div>
      <div className="flex items-start gap-4">
        <Bus className="w-12 " />
        <p>
          Servizio navetta attivo dal parcheggio più distante fino all’ingresso
          della location.
        </p>
      </div>
    </div>
  </div>
</section>

  );
}
